<template>
  <div class="ui-body">
    <dl class="head">
      <dt>{{date}}</dt>
      <dd>{{time}}</dd>
    </dl>
    <dl class="body">
      <dd>
        <ul>
          <li>
            <ve-bar
              :data="data"
              :grid="grid"
              :frame="barSettings.frame"
              :settings="barSettings"
              :legend="legend"
              :height="height"
            ></ve-bar>
          </li>
          <li>
            <ve-histogram
              :data="data"
              :grid="grid"
              :frame="histogramSettings.frame"
              :settings="histogramSettings"
              :legend="legend"
              :height="height"
            ></ve-histogram>
          </li>
          <li>
            <ve-table :data="dataSimple" :frame="tableframe" :height="height" :maxHeight="130"></ve-table>
          </li>
        </ul>
      </dd>
      <dt>
        <ve-warning
          :data="data"
          :grid="grid"
          :frame="lineSettings.frame"
          :settings="lineSettings"
          :legend="legend"
          :tooltipFormatter="tooltipFormatter"
          :height="height"
        ></ve-warning>
        <div class="icon-warning">
          <img
            class="warning"
            src="//cform-sensetime.oss-cn-hangzhou.aliyuncs.com/stchart/icon-warning.png"
          />
        </div>
      </dt>
      <dd>
        <ul>
          <li>
            <ve-pie
              :data="dataSimple"
              :grid="grid"
              :frame="pieSettings.frame"
              :settings="pieSettings"
              :legend="legend2"
              :height="height"
            ></ve-pie>
          </li>
          <li>
            <ve-ring
              :data="dataSimple"
              :grid="grid"
              :frame="ringSettings.frame"
              :settings="ringSettings"
              :legend="legend2"
              :height="height"
            ></ve-ring>
          </li>
          <li>
            <ve-line
              :data="data"
              :grid="grid"
              :frame="lineSettings.frame"
              :settings="lineSettings"
              :legend="legend"
              :tooltipFormatter="tooltipFormatter"
              :height="height"
            ></ve-line>
          </li>
        </ul>
      </dd>
    </dl>
  </div>
</template>

<script>
/* eslint-disable */
import echarts from "echarts";
export default {
  name: "case",
  data() {
    return {
      date: "",
      time: "",
      data: {
        columns: ["日期", "名称"],
        rows: [
          { 日期: "1954 年", 名称: 123 },
          { 日期: "1955 年", 名称: 1223 },
          { 日期: "1956 年", 名称: 2123 },
          { 日期: "1957 年", 名称: 4123 },
          { 日期: "1958 年", 名称: 3123 }
        ]
      },
      grid: {
        left: 10,
        right: 10,
        top: 25
      },
      dataSimple: {
        columns: ["日期", "名称"],
        rows: [{ 日期: "1954 年", 名称: 523 }, { 日期: "1955 年", 名称: 1223 }]
      },
      barSettings: {
        barWidth: 15,
        itemStyle: {
          normal: {
            // barBorderRadius: [0, 6, 6, 0],
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              { offset: 0, color: "#6C30F3" },
              { offset: 1, color: "#188EFF" }
            ])
          }
        },
        frame: {
          icon: "icon_transparency-1",
          title: "这是条形图标题",
          subtitle: "这是条形图副标题"
        },
        offsetY: 60
      },
      histogramSettings: {
        barWidth: 20,
        itemStyle: {
          normal: {
            // barBorderRadius: [6, 6, 0, 0],
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#188EFF" },
              { offset: 1, color: "#6C30F3" }
            ])
          }
        },
        frame: {
          icon: "icon_transparency-8",
          title: "这是柱状图标题",
          subtitle: "这是柱状图副标题"
        },
        offsetY: 60
      },
      lineSettings: {
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#188EFF" },
              { offset: 1, color: "#6C30F3" }
            ])
          }
        },
        frame: {
          icon: "icon_transparency-5",
          title: "这是标题",
          subtitle: "这是折线图副标题"
        },
        offsetY: 60
      },
      pieSettings: {
        label: {
          normal: {
            textStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            }
          }
        },
        labelLine: {
          normal: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            },
            smooth: 0.2,
            length: 10,
            length2: 20
          }
        },
        radius: 50,
        offsetY: 70,
        frame: {
          icon: "icon_transparency-",
          title: "这是饼图标题",
          subtitle: "这是饼图副标题"
        }
      },
      ringSettings: {
        label: {
          normal: {
            textStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            }
          }
        },
        labelLine: {
          normal: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            },
            smooth: 0.2,
            length: 10,
            length2: 20
          }
        },
        radius: [30, 50],
        offsetY: 70,
        frame: {
          icon: "icon_transparency-6",
          title: "这是环形图标题",
          subtitle: "这是环形图副标题"
        }
      },
      settings: {},
      height: "27vh",
      xAxis: {
        axisLabel: {
          color: "#666"
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: "rgba(255,255,255,0.2)",
            type: "solid"
          }
        }
      },
      yAxis: {
        axisLabel: {
          color: "#666"
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "rgba(255,255,255,0.2)",
            type: "solid"
          }
        }
      },
      legend: {
        show: false
      },
      legend2: {
        bottom: "25%",
        itemWidth: 10,
        itemHeight: 6,
        textStyle: {
          color: "#666"
        }
      },
      tableframe: {
        icon: "icon_transparency-5",
        title: "这是环形图标题",
        subtitle: "这是环形图副标题"
      },
      tooltipFormatter: function(e) {
        debugger;
      }
    };
  },
  mounted() {
    this.setTime();
    setInterval(() => {
      this.setTime();
    }, 1000);
  },
  methods: {
    setTime() {
      const d = new Date();
      const t = {
        M: d.getMonth() + 1,
        d: d.getDate(),
        h: d.getHours(),
        m: d.getMinutes(),
        s: d.getSeconds()
      };
      for (let key in t) {
        t[key] = t[key] > 9 ? t[key] : "0" + t[key];
      }
      this.date = d.getFullYear() + "-" + t.M + "-" + t.d;
      this.time = t.h + ":" + t.m + ":" + t.s;
    }
  }
};
</script>

<style>
html,
body {
  background-color: #080a1b;
  color: #fff;
  background: #080a1b
    url(//cform-sensetime.oss-cn-hangzhou.aliyuncs.com/stchart/bg-blue.png) left
    top no-repeat;
  background-size: auto 120%;
}
.ui-body {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.head {
  text-align: center;
}

.head dt {
  font-size: 24px;
  font-family: DINPro;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  line-height: 31px;
  padding: 15px 0 3px;
}

.head dd {
  font-size: 40px;
  font-family: DINPro;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 52px;
  background: url(//cform-sensetime.oss-cn-hangzhou.aliyuncs.com/stchart/icon-time.svg)
    center center no-repeat;
  background-size: 100%;
  width: 557px;
  margin: 0 auto;
}

.body {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0 40px;
}

.body > dt {
  flex: 1;
}

.body > dt .icon-warning {
  text-align: center;
}

.body > dt .warning {
  width: 160px;
  margin-top: -50px;
}

.body > dd {
  width: 22vw;
}

.body li:last-child {
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Case.vue